<template>
    <div class="goods_content">
        <div class="goods_box">
            <div class="goods_left">
                <!-- 商品分类 -->
                <div class="goods_classify_content">
                    <h3>商品分类</h3>
                    <span :class="{'active': open}" @click="openclose(goodsclassify)">展开<i class="icon iconfont icon-icon_zhankai_xiangxia"></i></span>
                </div>
                <div class="goods_classify_list">
                    <Tree :data="goodsclassify" @on-select-change="classifyChange"></Tree>
                </div>
            </div>
            <div class="goods_right">
                <!-- 商品标签 -->
                <div class="goods_label_content">
                    <div class="goods_label_box">
                        <span>品牌：</span>
                        <ul>
                            <li
                                :class="{'active': index == brandSign}"
                                v-for="(item, index) in goodslabel.brand"
                                :key="index"
                                @click="brandClick(item.id, index)"
                            >{{item.name}}</li>
                        </ul>
                    </div>
                    <div class="goods_label_box">
                        <span>标签：</span>
                        <ul>
                            <li
                                :class="{'active': index == labelsSign}"
                                v-for="(item, index) in goodslabel.labels"
                                :key="index"
                                @click="labelsClick(item, index)"
                            >{{item}}</li>
                        </ul>
                    </div>
                    <div class="goods_label_box">
                        <ul>
                            <li
                                :class="{'active': index == tagSign}"
                                v-for="(item, index) in goodslabel.tag"
                                :key="index"
                                @click="tagClick(index)"
                            >{{item}}</li>
                        </ul>
                    </div>
                </div>
                <!-- 排序 -->
                <div class="goods_sort_content">
                    <div class="goods_sort_left">
                        <span :class="{'active': goodsortSign == index}" v-for="(item, index) in goodsort" :key="index" @click="sortClick(index)">{{item}}</span>
                    </div>
                    <div class="goods_sort_right">
                        <i class="icon iconfont icon-dianliang1" :class="{'active': goodslistinfo.goodsliststyle == 1}" @click="liststyleClick(1)"></i>
                        <i class="icon iconfont icon-qiehuanliebiao" :class="{'active': goodslistinfo.goodsliststyle == 2}" @click="liststyleClick(2)"></i>
                    </div>
                </div>
                <!-- 商品列表 -->
                <goodsList ref="goodslist" :type="type" :goodslistinfo="goodslistinfo"></goodsList>
            </div>
        </div>
        <!-- 多规格弹窗 -->
    </div>
</template>

<script>
import api from '@/request/api.js'
import {toMoney} from '@/filter/moneyFilter.js'
import goodsList from "@/components/views/goods/goodslist.vue"
export default {
    components: { goodsList },
    props: ['searchsign', 'searchname'],
    data() {
        return {
            num: 0,
            norms: { // 多规格信息
                goodslist: [], // 商品列表
                goodsattr: [], // 商品规格
                det: [], // 商品规格组合
            },
            open: false, // 是否全部展开
            goodsclassify: [], // 商品分类
            brandSign: 0, // 品牌当前选中
            labelsSign: 0, // 标签当前选中
            tagSign: 0, // 标牌当前选中
            goodslabel: { // 标签列表
                brand: [{id: 0, name: '全部'}],
                labels: ['全部'],
                tag: []
            },
            goodsortSign: 0, // 商品排序当前选中
            goodsortnum: 0, // 商品排序 价格、销量 点击几次
            goodsort: ['默认', '价格', '销量'], // 商品排序
            type: 0, // 商品列表组件类型 0 商品列表 1 收藏的商品 2 看过的商品
            goodslistinfo: { // 商品列表组件信息
                goodsliststyle: 1, // 商品列表样式
                catid: null, // 商品分类id
                brandid: 0, // 品牌id
                labelids: '', // 标签
                searchtype: 0, // 标牌id 0 全部 1 折扣 2 特价 3 订过的 4 收藏 5 有货
                sortname: '', // 默认  价格 mincost 销量 sellcount
                sortorder: '', // asc/desc
                queryname: '', // 首页搜索名字
            }
        }
    },
    methods: {
        getGoodsClassify () { // 获取商品分类
            this.http.post(api.goodsclassify)
            .then(response => {
                // console.log(response.data.msg)
                // 商品分类
                this.goodsclassify = response.data.msg.goodscatlist
                // 品牌
                this.goodslabel.brand = this.goodslabel.brand.concat(response.data.msg.brand_brandlist)
                // 标签
                this.goodslabel.labels = this.goodslabel.labels.concat(response.data.msg.label_goods)
                // 标牌
                this.goodslabel.tag = response.data.msg.searchtype
                // 判断路由type类型 0 展示所有 1 只显示有新品标签的商品
                if (this.$route.params.type == 1) {
                    this.goodslistinfo.labelids = response.data.msg.label_goods[0]
                    this.labelsSign = 1
                } else {
                    this.goodslistinfo.labelids = ''
                }
                this.$refs.goodslist.updatelist()
            })
            .catch(error => {
                console.log(error);
            })
        },
        openclose (list) { // 点击展开商品分类
            this.open = !this.open
            this.opencloseSet(list)
        },
        opencloseSet (list) { // 商品分类递归循环
            for (var i in list) {
                list[i].expand = this.open
                if (list[i].children) {
                    this.opencloseSet(list[i].children)
                }
            }
        },
        classifyChange (e) { // 点击商品分类
            this.goodslistinfo.catid = e[0].id
            this.$refs.goodslist.updatelist()
        },
        brandClick (id, index) { // 点击品牌
            this.brandSign = index
            this.goodslistinfo.brandid = id
            this.$refs.goodslist.updatelist()
        },
        labelsClick (item, index) { // 点击标签
            this.labelsSign = index
            index == 0 ? this.goodslistinfo.labelids = '' : this.goodslistinfo.labelids = item
            this.$refs.goodslist.updatelist()
        },
        tagClick (index) { // 点击标牌
            this.tagSign = this.goodslistinfo.searchtype = index
            this.$refs.goodslist.updatelist()
        },
        sortClick (index) { // 点击排序
            if (this.goodsortSign != index) {
                this.goodsortnum = 0
            } else {
                if (this.goodsortnum >= 1) {
                    this.goodsortnum = 0
                } else {
                    if (index == 1 || index == 2) {
                        this.goodsortnum++
                    }
                }
            }
            this.goodsortSign = index
            if (index == 0) {
                this.goodslistinfo.sortname = ''
                this.goodslistinfo.sortorder = ''
            }
            if (index == 1 && this.goodsortnum == 0) {
                this.goodslistinfo.sortname = 'mincost'
                this.goodslistinfo.sortorder = 'desc'
            } else if (index == 1 && this.goodsortnum == 1) {
                this.goodslistinfo.sortname = 'mincost'
                this.goodslistinfo.sortorder = 'asc'
            }
            if (index == 2 && this.goodsortnum == 0) {
                this.goodslistinfo.sortname = 'sellcount'
                this.goodslistinfo.sortorder = 'desc'
            } else if (index == 2 && this.goodsortnum == 1) {
                this.goodslistinfo.sortname = 'sellcount'
                this.goodslistinfo.sortorder = 'asc'
            }
            this.$refs.goodslist.updatelist()
            // console.log(this.goodsortnum)
        },
        liststyleClick (index) { // 切换商品列表样式
            this.goodslistinfo.goodsliststyle = index
        },
        searchgoods () { // 顶部右侧搜索
            if (this.searchsign == 'goods') {
                this.goodslistinfo.queryname = this.searchname
                setTimeout(() => {
                    this.$refs.goodslist.updatelist()
                }, 0)
            }
        }
    },
    created () {
        this.getGoodsClassify()
        this.searchgoods()
    },
    watch: {
        searchname () {
            this.searchgoods()
        }
    },
    filters: {
        moneyFilter (money) {
            return toMoney(money)
        }
    },
}
</script>

<style scoped>

.goods_content {
    padding: 30px;
}

.goods_box {
    display: flex;
    flex-direction: row;
}

.goods_left {
    width: 240px;
    height: 682px;
    flex-grow: 0;
    flex-shrink: 0;
    margin-right: 20px;
    border: 1px solid #E7EBF6;
    border-radius: 4px 4px 10px 10px;
}

.goods_classify_content {
    height: 40px;
    padding: 0 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: #E7EBF6;
    border-radius: 4px 4px 0 0;
}

.goods_classify_content > h3 {
    font-size: 16px;
    color: #666;
    font-weight: normal;
}

.goods_classify_content > span {
    font-size: 12px;
    color: #999;
    cursor: pointer;
}

.goods_classify_content > span > i {
    margin-left: 5px;
    font-size: 12px;
    display: inline-block;
    color: #ccc;
    transition: all .2s;
}

.goods_classify_content > span.active > i {
    transform: rotate(180deg);
}

.goods_classify_list {
    height: 642px;
    padding: 12px 20px;
    overflow: auto;
}

.goods_right {
    width: 10px;
    flex-grow: 1;
    flex-shrink: 1;
}

.goods_label_content {
    min-height: 114px;
    padding: 10px 0 20px 20px;
    background-color: rgba(91, 95, 194, 0.04);
}

.goods_label_box {
    display: flex;
    flex-direction: row;
}

.goods_label_box > span {
    height: 16px;
    line-height: 16px;
    flex-grow: 0;
    flex-shrink: 0;
    margin-top: 12px;
    font-size: 16px;
    color: #0C1F6D;
}

.goods_label_box > ul {
    width: 10px;
    flex-grow: 1;
    flex-shrink: 1;
    font-size: 0;
}

.goods_label_box > ul > li {
    height: 20px;
    line-height: 20px;
    padding: 0 10px;
    margin: 10px 10px 0 0;
    font-size: 12px;
    color: #666;
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 2px;
    transition: all .2s;
    cursor: pointer;
}

.goods_label_box > ul > li.active,
.goods_label_box > ul > li:hover {
    color: #FF8000;
    border-color: #FF8000;
}

.goods_sort_content {
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    margin-top: 10px;
    background-color: #E7EBF6;
    border-radius: 5px 5px 0 0;
}

.goods_sort_left > span {
    margin-right: 30px;
    font-size: 14px;
    color: #666;
    transition: all .2s;
    cursor: pointer;
}

.goods_sort_left > span.active,
.goods_sort_left > span:hover,
.goods_sort_right > i.active,
.goods_sort_right > i:hover {
    color: #FF8000;
}

.goods_sort_right > i {
    margin-left: 20px;
    font-size: 14px;
    color: #999;
    vertical-align: middle;
    transition: all .2s;
    cursor: pointer;
}

.goods_sort_right > i.icon-dianliang1 {
    font-size: 16px;
}

</style>


// WEBPACK FOOTER //
// src/components/views/goods/goods.vue